import { Steps } from "components/Steps/Steps";
import { FormattedMessage } from "react-intl";

export const HowWorks = () => {
	const steps = [
		{ number: 1, titleKey: "APP.HOW.WORKS.SECTION.STEP.ONE.TITLE", desc1Key: "APP.HOW.WORKS.SECTION.STEP.ONE.DESCRIPTION.1", desc2Key: "APP.HOW.WORKS.SECTION.STEP.ONE.DESCRIPTION.2" },
		{ number: 2, titleKey: "APP.HOW.WORKS.SECTION.STEP.TWO.TITLE", desc1Key: "APP.HOW.WORKS.SECTION.STEP.TWO.DESCRIPTION.1", desc2Key: "APP.HOW.WORKS.SECTION.STEP.TWO.DESCRIPTION.2" },
		{ number: 3, titleKey: "APP.HOW.WORKS.SECTION.STEP.SMS.TITLE", desc1Key: "APP.HOW.WORKS.SECTION.STEP.SMS.DESCRIPTION.1", desc2Key: "APP.HOW.WORKS.SECTION.STEP.ONE.DESCRIPTION.2" },
		{ number: 4, titleKey: "APP.HOW.WORKS.SECTION.STEP.THREE.TITLE", desc1Key: "APP.HOW.WORKS.SECTION.STEP.THREE.DESCRIPTION.1", desc2Key: "APP.HOW.WORKS.SECTION.STEP.THREE.DESCRIPTION.2" },
		{ number: 5, titleKey: "APP.HOW.WORKS.SECTION.STEP.FOUR.TITLE", desc1Key: "APP.HOW.WORKS.SECTION.STEP.FOUR.DESCRIPTION.1", desc2Key: "APP.HOW.WORKS.SECTION.STEP.FOUR.DESCRIPTION.2" },
		{ number: 6, titleKey: "APP.HOW.WORKS.SECTION.STEP.FIVE.TITLE", desc1Key: "APP.HOW.WORKS.SECTION.STEP.FIVE.DESCRIPTION.1", desc2Key: "APP.HOW.WORKS.SECTION.STEP.FIVE.DESCRIPTION.2" },
		{ number: 7, titleKey: "APP.HOW.WORKS.SECTION.STEP.SIX.TITLE", desc1Key: "APP.HOW.WORKS.SECTION.STEP.SIX.DESCRIPTION.1", desc2Key: "APP.HOW.WORKS.SECTION.STEP.SIX.DESCRIPTION.2" },
	];

	return (
		<section className="section relative overflow-hidden">
			{/* Background grid pattern */}
			<div className="absolute inset-0 bg-grid opacity-50" />
			<div className="absolute top-0 right-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl -translate-y-1/2" />
			<div className="absolute bottom-0 left-0 w-72 h-72 bg-accent/5 rounded-full blur-3xl translate-y-1/2" />

			<div className="container-main relative">
				{/* Section Header */}
				<div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
					<span className="badge mb-4">Proceso</span>
					<h2 className="text-display-md md:text-display-lg text-primary mb-4">
						<FormattedMessage id="APP.NAV.HOW.WORKS.LABEL" />
					</h2>
					<p className="text-body-lg text-surface-600">
						<FormattedMessage id="APP.HOW.WORKS.SECTION.DESCRIPTION" />
					</p>
				</div>

				{/* Steps Grid */}
				<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
					{steps.map((step) => (
						<Steps
							key={step.number}
							number={step.number}
							stepTitleKey={step.titleKey}
							stepDescOneKey={step.desc1Key}
							stepDescTwoKey={step.desc2Key}
						/>
					))}
				</div>

				{/* CTA Card */}
				<div className="mt-16 md:mt-20">
					<div className="relative bg-gradient-to-br from-primary via-brand-900 to-primary rounded-3xl p-8 md:p-12 overflow-hidden">
						{/* Background decorations */}
						<div className="absolute top-0 right-0 w-64 h-64 bg-accent/10 rounded-full blur-3xl" />
						<div className="absolute bottom-0 left-0 w-48 h-48 bg-accent/5 rounded-full blur-2xl" />

						<div className="relative flex flex-col md:flex-row items-center justify-between gap-8">
							{/* Text content */}
							<div className="text-center md:text-left">
								<div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent/20 border border-accent/30 rounded-full mb-4">
									<span className="relative flex h-2 w-2">
										<span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"></span>
										<span className="relative inline-flex rounded-full h-2 w-2 bg-accent"></span>
									</span>
									<span className="text-caption font-semibold text-accent">Proceso 100% digital</span>
								</div>
								<h3 className="text-display-sm md:text-display-md text-white mb-3">
									¿Listo para comenzar?
								</h3>
								<p className="text-body-md text-white/70 max-w-md">
									Descarga la app, completa tu solicitud en minutos y recibe tu dinero en tiempo récord.
								</p>
							</div>

							{/* CTA Button */}
							<div className="flex flex-col items-center md:items-end gap-4">
								<a
									href="#downloads"
									className="group inline-flex items-center gap-3 px-8 py-4 bg-accent hover:bg-accent-light text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
								>
									<svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
										<path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/>
									</svg>
									Descargar App
									<svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
									</svg>
								</a>
								<span className="text-caption text-white/50">Disponible en Google Play</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
